export function searchQuery(search) {
    return "search:" + search;
}
export function classSurroundingsQuery(id) {
    return "surroundings:" + id;
}
export function classQuery(id) {
    return "class:" + id;
}
//# sourceMappingURL=queries.js.map